const markerDefaults = {
  color: '#FFFFFF',
  size: 75,
  circleRadius: 0.04,
  borderInnerRadius: 0.15,
  borderOuterRadius: 0.20,
  animates: true,
};

export default markerDefaults;
